import { createRouter, createWebHashHistory } from 'vue-router'

import { checksService } from '../services/checks.service'

import store from '../store'
import routes from './routes'

import config from '../../vue.config'

let isBackNavigation = false

window.addEventListener('popstate', () => {
  isBackNavigation = true
  //reset the flag after 100ms
  setTimeout(() => {
    isBackNavigation = false
  }, 100);
})

const router = createRouter({
  routes,
  history: createWebHashHistory(process.env.BASE_URL),
})

router.beforeEach((to, from, next) => {
  let checkRoutes = checksService.getChecksRoutes()
  // isBackNavigation is restored to false when the user navigates to a new route
  if (isBackNavigation && checkRoutes.includes(from.name)) {
    console.log('🚀 ~ router.beforeEach ~ checkRoutes:', checkRoutes)
    isBackNavigation = false
    console.log('🚀 ~ router.beforeEach ~ from.name:', from.name)
    if (from.name === 'FinancialReport') {
      return next(false) // Avoid redirection loop
    }
    checkRoutes.unshift('FinancialReport')
    // Find the index of the current route in the checkRoutes array
    const currentIndex = checkRoutes.indexOf(from.name)

    // If currentIndex is valid and it's not the first route, move back in the route order
    if (currentIndex > 0) {
      const previousRoute = checkRoutes[currentIndex - 1]
      if (previousRoute === 'FinancialReport') {
        const contact = store.getters.getFinancialReportContact
        if (contact) {
          // If contactId exists, navigate to 'FinancialReport' with contactId
          return next({
            name: previousRoute,
            params: { contactId: contact.ContactID },
          })
        }
      }
      return next({ name: previousRoute })
    }
  }
  isBackNavigation = false

  if (
    checkRoutes.includes(from.name) &&
    !checkRoutes.includes(to.name) &&
    !store.getters.isConfirmModalOpen
  ) {
    store.dispatch('showConfirmModal', { to, from, next })
    return next(false)
  }

  if (to.name === 'FinancialReport' && !to.params.contactId) {
    const contact = store.getters.getFinancialReportContact
    if (contact) {
      return next({
        name: to.name,
        params: { contactId: contact.ContactID },
      })
    }
  }
  //  console.log(to.fullPath, from.fullPath,"beforeEach");
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.label)
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)

  if (nearestWithTitle) {
    document.title = `${config.pwa.manifestOptions.short_name} - ${nearestWithTitle.meta.label}`
  } else if (previousNearestWithMeta) {
    document.title = `${config.pwa.manifestOptions.short_name} - ${previousNearestWithMeta.meta.label}`
  }

  Array.from(
    document.querySelectorAll('[data-vue-router-controlled]')
  ).map((el) => el.parentNode.removeChild(el))

  if (nearestWithMeta)
    nearestWithMeta.meta.metaTags
      .map((tagDef) => {
        const tag = document.createElement('meta')

        Object.keys(tagDef).forEach((key) => {
          tag.setAttribute(key, tagDef[key])
        })

        tag.setAttribute('data-vue-router-controlled', '')

        // console.log(tag);
        return tag
      })
      .forEach((tag) => document.head.appendChild(tag))
  // console.log("isLoggedIn",store.getters['api/isLoggedIn']);
  store.dispatch('api/checkLogIn').then(() => {
    if (to.matched.some((recorde) => !recorde.meta.public)) {
      if (!store.getters['api/isLoggedIn']) {
        console.log('api/isLoggedIn')
        store.commit('api/resetToken')
        store.commit('setPreviousPath', to.fullPath)
        return next({ name: 'Login' })
      }
    } else if (to.matched.some((recorde) => recorde.meta.public === 'only')) {
      console.log('api/isLoggedIn2')
      if (store.getters['api/isLoggedIn']) {
        if (to.name == 'Login') return next({ name: 'Dashboard' })
        else return next({ name: to.name })
      }
    }
    next()
  })
})

router.afterEach(() => {
  // window.history.replaceState(null, null, window.location.pathname);
})
export default router
